import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import config from '../../config';
import Header from '../Header';
import Footer from '../Footer';
import { format } from 'date-fns';
import PopupService from '../PopupService';
import { useApi } from '../../ApiContext';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { apiFetch } from '../utils/ApiFetch';
const AlertClient = () => {
	let lastClientId = null;
	let isEvenRow = false;
	let rowNumber = 1;
	const [activeTab, setActiveTab] = useState('tab1');
	const [receivedDate, setReceivedDate] = useState(null);
	const [clients, setClients] = useState([]);
	const [mrNumber, setMrNumber] = useState('');
	const [mrNumberTitle, setMrNumberTitle] = useState('');
	const [showMrNumberTitle, setShowMrNumberTitle] = useState(false);
	const [suggestions, setSuggestions] = useState([]);
	const { callApi, setIsApiLoading } = useApi();
	const [showSuggestions, setShowSuggestions] = useState(false);
	const [attachments, setAttachments] = useState([]);
	const [loading, setLoading] = useState(false);
	const [selectedClientId, setSelectedClientId] = useState('');
	const [showAlertDetails, setShowAlertDetails] = useState(false);
	const [supportAlert, setSupportAlert] = useState(null);
	const username = sessionStorage.getItem("username");
	const mrToken = localStorage.getItem("mr_token");
	const [saveForAllClients, setSaveForAllClients] = useState(false);
	const [emailNotices, setEmailNotices] = useState([]);
	const [noticeAttachments, setNoticeAttachments] = useState([]);
	const [clientAssociationNotifier, setClientAssociationNotifier] = useState('');
	const [clientAlertAttachments, setClientAlertAttachments] = useState([]);
	const [selectedFiles, setSelectedFiles] = useState([]);
	const [uploadForAllClients, setUploadForAllClients] = useState(false);
	const [recvdFromOthers, setRecvdFromOthers] = useState('');
	const [receivedMode, setReceivedMode] = useState('');
	const [miscInfo, setMiscInfo] = useState('');
	const [alertClients, setAlertClients] = useState([]);
	const [responseInfoList, setResponseInfoList] = useState([]);
	const showResponseInfoCard = Boolean((mrNumber ?? '').trim().length > 0);
	const [responseInfoServerTotal, setResponseInfoServerTotal] = useState(0);

	const CONTACT_INFO_TYPE_LABELS = {
		contact_info_response_form: 'Contact info for Returning Response Forms',
		contact_info_customer_support: 'Contact info for Questions about recall/customer support',
		contact_info_local_rep: 'Contact Local Representative',
		product_credit_replacement: 'Product/Component Replacement Or Credit Info',
		no_contact_info: 'No Contact Info included in recall',
		Other: 'Other',
	};
	const DEFAULT_PAGE_SIZE = 10;

	const asInt = (v, fallback) => {
		const n = Number.parseInt(String(v ?? ''), 10);
		return Number.isFinite(n) ? n : fallback;
	};

	const syncResponseInfoFromBackend = (data, { page } = {}) => {
		const list = Array.isArray(data?.data?.LIST_RESPONSE_INFO) ? data.data.LIST_RESPONSE_INFO : [];
		const totalCountRaw = data?.data?.total ?? data?.data?.totalCount ?? list.length;
		const totalCount = Number(totalCountRaw);

		setResponseInfoList(list);
		setResponseInfoServerTotal(Number.isFinite(totalCount) ? totalCount : list.length);

		if (page != null) setResponseInfoPage(page);
	};

	const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

	const buildPageWindow = (current, total, windowSize = 5) => {
		const half = Math.floor(windowSize / 2);
		let start = Math.max(1, current - half);
		let end = Math.min(total, start + windowSize - 1);
		start = Math.max(1, end - windowSize + 1);
		const pages = [];
		for (let p = start; p <= end; p += 1) pages.push(p);
		return pages;
	};



	const [responseInfoSearchInput, setResponseInfoSearchInput] = useState('');
	const [responseInfoAppliedSearch, setResponseInfoAppliedSearch] = useState('');

	const [responseInfoPage, setResponseInfoPage] = useState(1);
	const [responseInfoPageSize, setResponseInfoPageSize] = useState(DEFAULT_PAGE_SIZE);

	const [responseInfoPageJump, setResponseInfoPageJump] = useState('');



	const getContactInfoTypeLabel = (v) => CONTACT_INFO_TYPE_LABELS[v] || (v ?? '');

	const flatRows = React.useMemo(() => {
		const rows = [];
		alertClients.forEach((client, clientIdx) => {
			const entries = client.alertClientEntry || [];
			entries.forEach((entry, idx) => {
				rows.push({
					clientId: client.clientId,
					mongoId: client.mongoId,
					entry,
					isFirst: idx === 0,
					clientIdx,
					entryIdx: idx
				});
			});
		});
		return rows;
	}, [alertClients]);



	const responseInfoTotal = useMemo(() => responseInfoServerTotal, [responseInfoServerTotal]);

	const responseInfoTotalPages = useMemo(() => {
		return Math.max(1, Math.ceil((responseInfoTotal || 0) / responseInfoPageSize));
	}, [responseInfoTotal, responseInfoPageSize]);

	useEffect(() => {
		setResponseInfoPage((p) => clamp(p, 1, responseInfoTotalPages));
	}, [responseInfoTotalPages]);



	const responseInfoPageWindow = useMemo(() => {
		return buildPageWindow(responseInfoPage, responseInfoTotalPages, 5);
	}, [responseInfoPage, responseInfoTotalPages]);

	/** ---- actions ---- */
	useEffect(() => {
		// keep page in range if total/pagesize changes
		setResponseInfoPage((p) => clamp(p, 1, responseInfoTotalPages));
	}, [responseInfoTotalPages]);

	useEffect(() => {
		setResponseInfoPageJump(String(responseInfoPage));
	}, [responseInfoPage]);

	const onResponseInfoChangePageSize = async (e) => {
		const nextSize = Number.parseInt(e?.target?.value, 10) || DEFAULT_PAGE_SIZE;

		// update state for UI
		setResponseInfoPageSize(nextSize);
		setResponseInfoPage(1);
		setResponseInfoPageJump("1");

		// IMPORTANT: call API with `nextSize` (not `responseInfoPageSize`)
		await reloadResponseInfo({
			page: 1,
			pageSize: nextSize,
			term: responseInfoAppliedSearch,
		});
	};

	const onResponseInfoSearchClick = async () => {
		const term = String(responseInfoSearchInput ?? '').trim();
		setResponseInfoAppliedSearch(term);
		await reloadResponseInfo({ page: 1, limit: responseInfoPageSize, term });
	};



	const submitResponseInfoPageJump = async () => {
		if (!String(responseInfoPageJump ?? '').trim()) return;
		await goToResponseInfoPage(responseInfoPageJump);
	};

	const reloadResponseInfo = async (opts = {}) => {
		const page = clamp(asInt(opts.page, responseInfoPage), 1, Number.MAX_SAFE_INTEGER);
		const limit = clamp(asInt(opts.pageSize, responseInfoPageSize), 1, 1000);
		const term = String(opts.term ?? responseInfoAppliedSearch ?? '').trim();

		if (!String(mrNumber ?? '').trim()) {
			setResponseInfoList([]);
			setResponseInfoServerTotal(0);
			setResponseInfoPage(1);
			return;
		}

		setIsApiLoading(true);
		try {
			const resp = await apiFetch(`${config.API_BASE_URL}/alertInfoClients`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-Username': username,
					'Authorization': `Bearer ${mrToken}`,
				},
				body: JSON.stringify({
					mrNumber,
					page,
					limit,
					searchTerm: term,
				}),
			});

			if (!resp.ok) {
				setResponseInfoList([]);
				setResponseInfoServerTotal(0);
				return;
			}

			const data = await resp.json();
			syncResponseInfoFromBackend(data, { page });
		} finally {
			setIsApiLoading(false);
		}
	};

	const goToResponseInfoPage = async (nextPage) => {
		const p = clamp(asInt(nextPage, 1), 1, responseInfoTotalPages);
		await reloadResponseInfo({ page: p, limit: responseInfoPageSize, term: responseInfoAppliedSearch });
	};



	const onResponseInfoRefreshClick = async () => {
		await reloadResponseInfo({ page: 1, limit: responseInfoPageSize, term: responseInfoAppliedSearch });
	};


	const onResponseInfoCancelClick = async () => {
		setResponseInfoSearchInput('');
		setResponseInfoAppliedSearch('');
		await reloadResponseInfo({ page: 1, limit: responseInfoPageSize, term: '' });
	};


	// Combine attachments and clientAlertAttachments

	const allAttachments = [
		...attachments.map(file => ({
			type: 'alert',
			id: file.mongoId,
			fileName: file.fileName,
			clientId: file.clientId,
			attachmentType: file.attachmentType || 'SA'
		})),
		...Object.entries(clientAlertAttachments).flatMap(([mongoId, attList]) =>
			attList.map(att => ({
				type: 'client',
				id: att[0],           // attachmentId
				fileName: att[1],     // filename
				clientId: selectedClientId,
				attachmentType: att[2]
				// <-- map key added here
			}))
		)
	];



	// Add these state variables at the top with other useState hooks
	const [crInfo, setCrInfo] = useState({
		contactPerson: '',
		phone: '',
		email: '',
		response: ''
	});

	const emptyCrInfo = {
		contactPerson: '', phoneContact: '', emailContact: '', contactInfoOther: '',
		contactInfoType: '', companyDeptGroup: '', faxContact: '', titleContactPerson: '',
		streetAddress: '', streetAddress2: '', contactCity: '', contactState: '', contactZip: ''
	};
	const [crInfoId, setCrInfoId] = useState(null);

	// JavaScript
	useEffect(() => {
		setCrInfo({ ...emptyCrInfo });
		setCrInfoId(null);
		setMrNumber('');
		setSelectedClientId('');
		setResponseInfoList([]); // <-- add
		// Reset other form states as needed
	}, []);

	useEffect(() => {
		const fetchClients = async () => {
			try {
				const response = await apiFetch(`${config.API_BASE_URL}/activeclients`,
					{ headers: { 'Content-Type': 'application/json', 'X-Username': username, 'Authorization': `Bearer ${mrToken}` } },
				);
				if (response.ok) {
					const data = await response.json();
					setClients(Array.isArray(data.data.ACTIVE_CLIENTS) ? data.data.ACTIVE_CLIENTS : []);
				}
			} catch (err) {
				setClients([]);
			}
		};
		fetchClients();
	}, []);

	const handleDeleteResponseInfoRow = async (ri) => {
		const mongoId = ri?.mongoId || ri?.id; // backend may send either
		const clientId = ri?.clientId || '';
		const typeLabel = getContactInfoTypeLabel(ri?.contactInfoType);

		if (!mongoId) {
			PopupService.getInstance().showMessage('Missing row identifier (mongoId)', false);
			return;
		}

		const confirmed = await PopupService.getInstance().showConfirm(
			`Are you sure you would like to delete the client response info for Client ID: ${clientId} and Contact Info Type: ${typeLabel}?`
		);
		if (!confirmed) return;

		setIsApiLoading(true);
		try {
			const resp = await apiFetch(`${config.API_BASE_URL}/deletecrinfo`, {
				method: 'DELETE',
				headers: {
					'Content-Type': 'application/json',
					'X-Username': username,
					'Authorization': `Bearer ${mrToken}`,
				},
				body: JSON.stringify({ mongoId }),
			});

			const result = await resp.json().catch(() => ({}));

			if (!(resp.ok && result?.statusCode === 200)) {
				PopupService.getInstance().showMessage(result?.message || 'Failed to delete', false);
				return;
			}

			// Remove from table immediately
			setResponseInfoList((prev) => prev.filter((x) => (x?.mongoId || x?.id) !== mongoId));
			PopupService.getInstance().showMessage(result?.message || 'Client Response Info deleted successfully', true);
		} catch {
			PopupService.getInstance().showMessage('Error deleting client response info', false);
		} finally {
			setIsApiLoading(false);
		}
	};


	const handleMrNumberChange = async (e) => {
	  // Clear Response Info search + paging when MR Number changes
	  setResponseInfoSearchInput('');
	  setResponseInfoAppliedSearch('');
	  setResponseInfoPage(1);
	  setResponseInfoPageJump('1');

	  setResponseInfoList([]);
	  setResponseInfoServerTotal(0);
	  setClientAssociationNotifier('');
	  setAttachments([]);
	  setEmailNotices([]);
	  setNoticeAttachments([]);
	  setClientAlertAttachments([]);
	  setAlertClients([]);
	  setLoading(true);

	  await callApi(async () => {
	    setIsApiLoading(true);
	    const value = e.target.value;
	    setMrNumber(value);
	    setShowMrNumberTitle(false);
	    setMrNumberTitle('');

	    if (value.trim().length < 8) {
	      setSuggestions([]);
	      setShowSuggestions(false);
	      return;
	    }

	    try {
	      const response = await apiFetch(
	        `${config.API_BASE_URL}/mrnumbers?searchString=${encodeURIComponent(value)}`,
	        {
	          headers: {
	            'Content-Type': 'application/json',
	            'X-Username': username,
	            'Authorization': `Bearer ${mrToken}`,
	          },
	        }
	      );

	      if (response.ok) {
	        const text = await response.text();
	        let data;
	        try {
	          data = JSON.parse(text);
	        } catch (err) {
	          setSuggestions([]);
	          setShowSuggestions(false);
	          return;
	        }

	        const filtered = Array.isArray(data.data)
	          ? data.data.filter((obj) => obj && (obj.mrNumber || obj.mr_number))
	          : [];

	        const normalized = filtered.map((obj) => ({
	          mrNumber: obj.mrNumber || obj.mr_number,
	        }));

	        setSuggestions(normalized);
	        setShowSuggestions(normalized.length > 0);
	      } else {
	        setSuggestions([]);
	        setShowSuggestions(false);
	      }
	    } catch (err) {
	      setSuggestions([]);
	      setShowSuggestions(false);
	    } finally {
	      setLoading(false);
	      setIsApiLoading(false);
	    }
	  });
	};

	// Handler function



	const handleClientChange = async (e) => {
		setEmailNotices([]); // Initialize email_notices_div
		setNoticeAttachments([]); // Initialize notice_attachment_div
		setLoading(true);
		await callApi(async () => {
			const clientId = e.target.value;
			setSelectedClientId(clientId);

			if (!mrNumber || mrNumber.trim() === "") {
				PopupService.getInstance()
					.showMessage('You must enter MR Number, it is a required field', false, 4000);
				setAttachments([]);
				setEmailNotices([]);
				setNoticeAttachments([]);
				return;
			}

			if (!clientId) {
				setAttachments([]);
				setEmailNotices([]);
				setNoticeAttachments([]);
				return;
			}

			try {
				const response = await apiFetch(`${config.API_BASE_URL}/clientNoticeAlertAttachment`, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'X-Username': username, 'Authorization': `Bearer ${mrToken}` },
					body: JSON.stringify({ mrNumber, clientId }),
				});
				if (response.ok) {
					const data = await response.json();
					setAttachments(data?.data?.ATTACHMENT_LIST || []);
					setEmailNotices(data?.data?.NOTICE_TASK_LIST || []);
					setNoticeAttachments([]); // Clear notice_attachment_div on client change

					// After parsing data
					setClientAlertAttachments(data?.data?.ALERT_CLIENT_ATTCH_LIST || []);

					// After fetching and parsing data
					const assoc = data?.data?.ALERT_CLIENT_ASSOCIATED;
					if (assoc === "NO") {
						setClientAssociationNotifier(
							<span className="badge bg-primary">
								<i className="fa fa-times"></i>&nbsp;{clientId} Not associated for {mrNumber}
							</span>
						);
					} else if (assoc === "YES") {
						setClientAssociationNotifier(
							<span className="badge  bg-success">
								<i className="fa fa-tag"></i>&nbsp;{clientId} Associated for {mrNumber}
							</span>
						);
					} else {
						setClientAssociationNotifier('');
					}


				} else {
					setAttachments([]);
					setEmailNotices([]);
					setNoticeAttachments([]);
				}
			} catch {
				setAttachments([]);
				setEmailNotices([]);
				setNoticeAttachments([]);
			} finally {
				setLoading(false);
				setIsApiLoading(false);
			}
		});
	};


	const handleSuggestionClick = async (selectedObj) => {
		const selectedMr = selectedObj?.mrNumber ?? '';
		setMrNumber(selectedMr);
		setSuggestions([]);
		setShowSuggestions(false);
		setSelectedClientId('');
		setAttachments([]);
		setShowAlertDetails(false); // Collapse details on new selection
		setResponseInfoList([]); // clear while loading new MR

		try {
			const response = await apiFetch(`${config.API_BASE_URL}/alertInfoClients`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-Username': username,
					'Authorization': `Bearer ${mrToken}`
				},
				body: JSON.stringify({ mrNumber: selectedMr }),
			});

			if (response.ok) {
				const data = await response.json();

				const alertTitle = data?.data?.SUPPORT_ALERT?.alertTitle || 'No title found';
				setMrNumberTitle(alertTitle);
				setShowMrNumberTitle(true);
				setSupportAlert(data?.data?.SUPPORT_ALERT || null);

				const list = data?.data?.LIST_RESPONSE_INFO;
				syncResponseInfoFromBackend(data);

				setResponseInfoList(Array.isArray(list) ? list : []);
			} else {
				setMrNumberTitle('No title found');
				setShowMrNumberTitle(true);
				setSupportAlert(null);
				setResponseInfoList([]);
			}
		} catch {
			setMrNumberTitle('Error fetching title');
			setShowMrNumberTitle(true);
			setSupportAlert(null);
			setResponseInfoList([]);
		}
	};


	// Add this utility function at the top of your file or in a utils file
	function escapeHtml(text) {
		if (!text) return '';
		return text
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#039;');
	}


	function unescapeHtml(text) {
		if (!text) return '';
		const temp = document.createElement('textarea');
		temp.innerHTML = text;
		return temp.value;
	}


	const deleteAlertAttachment = async (id, clientId, attachmentType = 'SA') => {
		if (!mrNumber || !clientId || !id) {
			PopupService.getInstance().showMessage('Missing parameters: MR Number, Client ID, or Attachment ID', false);
			return;
		}
		const confirmed = await PopupService.getInstance().showConfirm(
			'Are you sure you want to delete this attachment?'
		);
		if (!confirmed) return;

		const formData = new FormData();
		formData.append('mrNumber', mrNumber);
		if (!selectedClientId) {
			formData.append('clientId', clientId);
		} else {
			formData.append('clientId', selectedClientId);
		}

		formData.append('attachmentId', id);
		formData.append('enteredBy', username);

		try {
			const response = await apiFetch(`${config.API_BASE_URL}/deleteAttachment`, {
				method: 'DELETE',
				headers: {
					'X-Username': username,
					'Authorization': `Bearer ${mrToken}`
				},
				body: formData
			});
			const result = await response.json();
			if (response.ok && result.statusCode === 200) {
				setAttachments((prev) => prev.filter((file) => file.mongoId !== id));
				PopupService.getInstance().showMessage(result.message || 'Attachment Deleted Successfully', true);
				setAlertClients(prev =>
					prev.map(client => ({
						...client,
						alertClientEntry: (client.alertClientEntry || []).map(entry => ({
							...entry,
							attachments: (entry.attachments || []).filter(att => att[0] !== id)
						}))
					}))
				);
			} else {
				PopupService.getInstance().showMessage(result.message || 'Failed to delete attachment', false);
			}
		} catch (error) {
			PopupService.getInstance().showMessage('Failed to delete attachment', false);
		}
	};



	// JavaScript

	// Remove the deleted client attachment from state after successful deletion
	const deleteClientAttachment = async (noticeAttachmentId, alertClientId) => {
		const confirmed = await PopupService.getInstance().showConfirm(
			'Are you sure you want to delete this client attachment?'
		);
		if (!confirmed) return;

		const formData = new FormData();
		formData.append('alertClientId', alertClientId);
		formData.append('attachmentId', noticeAttachmentId);
		formData.append('mrNumber', mrNumber);
		formData.append('clientId', alertClientId);
		formData.append('enteredBy', username);

		try {
			const response = await apiFetch(`${config.API_BASE_URL}/deleteClientAttachment`, {
				method: 'DELETE',
				headers: {
					'X-Username': username,
					'Authorization': `Bearer ${mrToken}`
				},
				body: formData
			});
			const result = await response.json();

			if (response.ok && result.statusCode === 200) {
				// Remove the deleted attachment from clientAlertAttachments

				setClientAlertAttachments(prev => {
					const updated = { ...prev };
					Object.keys(updated).forEach(key => {
						updated[key] = updated[key].filter(att => att[0] !== noticeAttachmentId);
						if (updated[key].length === 0) {
							delete updated[key];
						}
					});
					return updated;
				});

				PopupService.getInstance().showMessage(result.message || 'Client attachment deleted successfully', true);
			} else {
				PopupService.getInstance().showMessage(result.message || 'Failed to delete client attachment', false);
			}
		} catch (error) {
			PopupService.getInstance().showMessage('Failed to delete client attachment', false);
		}
	};



	const downloadAttachment = async (mongoId, fileName, attachmentType = 'SA') => {
		try {
			let url;
			if (attachmentType === 'NT') {
				url = `${config.API_BASE_URL}/downloadNTAttachment/${mongoId}`;
			} else {
				url = `${config.API_BASE_URL}/attachment_download/${mongoId}`;
			}
			const response = await fetch(url, {
				headers: {
					'X-Username': username,
					'Authorization': `Bearer ${mrToken}`
				}
			});
			if (!response.ok) throw new Error('Download failed');
			const blob = await response.blob();
			const downloadUrl = window.URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = downloadUrl;
			a.download = fileName;
			document.body.appendChild(a);
			a.click();
			a.remove();
			window.URL.revokeObjectURL(downloadUrl);
		} catch (e) {
			PopupService.getInstance().showMessage('Failed to download attachment', false);
		}
	};


	// Fetch client response info when client or MR number changes
	useEffect(() => {
		if (selectedClientId && mrNumber) {
			(async () => {
				try {
					const response = await apiFetch(`${config.API_BASE_URL}/clientresponseinfo`, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'X-Username': username,
							'Authorization': `Bearer ${mrToken}`
						},
						body: JSON.stringify({ client_id: selectedClientId, mr_number: mrNumber })
					});
					if (response.ok) {
						const data = await response.json();
						if (data?.data && data.data.CLIENT_CR_INFO) {
							setCrInfo({
								mrNumber: data.data.CLIENT_CR_INFO.mrNumber || '',
								contactPerson: data.data.CLIENT_CR_INFO.contactPerson || '',
								phoneContact: data.data.CLIENT_CR_INFO.phoneContact || '',
								emailContact: data.data.CLIENT_CR_INFO.emailContact || '',
								contactInfoOther: data.data.CLIENT_CR_INFO.contactInfoOther || '',
								contactInfoType: data.data.CLIENT_CR_INFO.contactInfoType || '',
								companyDeptGroup: data.data.CLIENT_CR_INFO.companyDeptGroup || '',
								faxContact: data.data.CLIENT_CR_INFO.faxContact || '',
								titleContactPerson: data.data.CLIENT_CR_INFO.titleContactPerson || '',
								streetAddress: data.data.CLIENT_CR_INFO.streetAddress || '',
								streetAddress2: data.data.CLIENT_CR_INFO.streetAddress2 || '',
								contactCity: data.data.CLIENT_CR_INFO.contactCity || '',
								contactState: data.data.CLIENT_CR_INFO.contactState || '',
								contactZip: data.data.CLIENT_CR_INFO.contactZip || ''
							});
							setCrInfoId(data.data.CLIENT_CR_INFO.mongoId || null);
						} else {
							setCrInfo({ ...emptyCrInfo });
							setCrInfoId(null);
						}
					}
				} catch {
					setCrInfo({ ...emptyCrInfo });
					setCrInfoId(null);
				}
			})();
		}
	}, [selectedClientId, mrNumber]);

	// Handler for form input changes
	const handleCrInfoChange = (e) => {
		const { name, value } = e.target;
		setCrInfo(prev => ({ ...prev, [name]: value }));
	};

	// Handler for form submit

	// src/components/alert/AlertClientInfo.js
	// Replace your existing handleCrInfoSubmit with this version.

	const handleCrInfoSubmit = async (e) => {
		e.preventDefault(); // prevent full page reload
		setIsApiLoading(true);

		try {
			// 1) Save CR info
			const saveResp = await apiFetch(`${config.API_BASE_URL}/savecrinfo`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-Username': username,
					'Authorization': `Bearer ${mrToken}`,
				},
				body: JSON.stringify({
					mongoId: crInfoId,
					clientId: saveForAllClients ? null : selectedClientId,
					mrNumber,
					...crInfo,
				}),
			});

			const saveResult = await saveResp.json();

			if (!(saveResp.ok && saveResult?.statusCode === 200)) {
				PopupService.getInstance().showMessage(saveResult?.message || 'Failed to save', false);
				return;
			}

			PopupService.getInstance().showMessage('Client Response Info saved successfully', true);

			// 2) Reload Response Info table (LIST_RESPONSE_INFO) from alertInfoClients
			const infoResp = await apiFetch(`${config.API_BASE_URL}/alertInfoClients`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-Username': username,
					'Authorization': `Bearer ${mrToken}`,
				},
				body: JSON.stringify({ mrNumber }),
			});

			if (infoResp.ok) {
				const infoData = await infoResp.json();
				const list = infoData?.data?.LIST_RESPONSE_INFO;
				syncResponseInfoFromBackend(infoData);

				setResponseInfoList(Array.isArray(list) ? list : []);
			} else {
				setResponseInfoList([]);
			}
		} catch (err) {
			PopupService.getInstance().showMessage('Error saving client response info', false);
		} finally {
			setIsApiLoading(false);
		}
	};


	const handleDeleteCrInfo = async (e) => {
		e.preventDefault();
		if (!crInfoId) return;
		try {
			const response = await apiFetch(`${config.API_BASE_URL}/deletecrinfo`, {
				method: 'DELETE',
				headers: {
					'Content-Type': 'application/json',
					'X-Username': username,
					'Authorization': `Bearer ${mrToken}`
				},
				body: JSON.stringify({ mongoId: crInfoId })
			});
			const result = await response.json();
			if (response.ok && result.statusCode === 200) {
				PopupService.getInstance().showMessage('Client Response Info deleted successfully', true);
				setCrInfo({ ...emptyCrInfo });
				setCrInfoId(null);
				setCrInfoId(null);
			} else {
				PopupService.getInstance().showMessage(result.message || 'Failed to delete', false);
			}
		} catch {
			PopupService.getInstance().showMessage('Error deleting client response info', false);
		}
	};




	const handleCBChanged = async (e) => {
		const checked = e.target.checked;
		const msgId = e.target.value;
		if (checked) {
			try {
				const response = await apiFetch(`${config.API_BASE_URL}/noticeAttachment`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-Username': username,
						'Authorization': `Bearer ${mrToken}`
					},
					body: JSON.stringify({ messageId: msgId })
				});
				if (response.ok) {
					const data = await response.json();
					setNoticeAttachments(prev => {
						const newAttachments = data?.data?.ATTACHMENT_LIST || [];
						const existingIds = new Set(prev.map(att => String(att.messageId)));
						const filteredNew = newAttachments.filter(att => !existingIds.has(String(att.messageId)));
						return [...prev, ...filteredNew];
					});
				}
			} catch {
				// Optionally handle error
			}
		} else {
			// Remove attachments with matching messageId

			// Remove attachments with matching messageId (which matches checkbox id and <li> id)
			setNoticeAttachments(prev =>
				prev.filter(att => String(att.messageId) !== String(e.target.id))
			);

		}
	};




	const handleFileChange = (event) => {
		const newFiles = Array.from(event.target.files);

		// Merge new files with existing, avoiding duplicates by name+size
		const mergedFiles = [
			...selectedFiles,
			...newFiles.filter(
				nf => !selectedFiles.some(sf => sf.name === nf.name && sf.size === nf.size)
			),
		];

		setSelectedFiles(mergedFiles);
		event.target.value = '';
	};


	// Remove file handler
	const handleRemoveFile = (index) => {
		setSelectedFiles(files => files.filter((_, i) => i !== index));
	};




	async function associateClient() {
		const form = document.getElementById('alertClientForm');
		const formData = new FormData(form);
		if (selectedFiles.length > 0) {
			selectedFiles.forEach((file) => {
				formData.append('attachment', file);
			});
		}
		formData.append('mrNumber', mrNumber);
		formData.append('clientId', selectedClientId);
		formData.append('enteredBy', username);

		setLoading(true);
		await callApi(async () => {
			try {
				const response = await apiFetch(`${config.API_BASE_URL}/saveAlertClient`, {
					method: 'POST',
					body: formData,
					headers: {
						'X-Username': username,
						'Authorization': `Bearer ${mrToken}`
					}
				});

				const result = await response.json();
				if (response.ok && result.statusCode === 200) {
					PopupService.getInstance().showMessage(result.message || 'AlertClient saved successfully', true);
					// Optionally reset form or update state here
					setSelectedFiles([]);
					setReceivedDate(null);
					setRecvdFromOthers('');
					setReceivedMode('');
					setMiscInfo('');
					//setSelectedClientId('');
					setAttachments([]);
					setEmailNotices([]);
					setNoticeAttachments([]);
					setClientAlertAttachments([]);
					setClientAssociationNotifier('');
					document.getElementById('alertClientForm').reset();
					await handleClientChange({ target: { value: selectedClientId } });
				} else {
					PopupService.getInstance().showMessage(result.message || 'Error saving AlertClient', false);
				}
			} catch (error) {
				PopupService.getInstance().showMessage('Error saving AlertClient', false);
			} finally {
				setLoading(false);
				setIsApiLoading(false);
			}
		});
	}

	const handleClickforAlertClient = async (selectedObj) => {
		setMrNumber(selectedObj.mrNumber);
		setSuggestions([]);
		setShowSuggestions(false);
		try {
			const response = await apiFetch(`${config.API_BASE_URL}/alertclientlist`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', 'X-Username': username, 'Authorization': `Bearer ${mrToken}` },
				body: JSON.stringify({ mrNumber: selectedObj.mrNumber }),
			});
			if (response.ok) {
				const data = await response.json();
				setAlertClients(data?.data?.ALERT_CLIENTS || []);
				setMrNumberTitle(data?.data?.SUPPORT_ALERT?.alertTitle || 'No title found');
			} else {
				setAlertClients([]);
				setMrNumberTitle('No title found');
			}
		} catch {
			setAlertClients([]);
			setMrNumberTitle('Error loading alert client info.');
		}
	};



	return (
		<>
			<Header />
			<div className="container-fluid text-secondary">
				<br />
				<br />
				<br />
				<div className="card text-secondary" >
					<div className="card-header">Alert Client Asscociation</div>
					<div className='card-body  custom-card-bg'>
						<div className="card">
							<div className="card-body">
								<ul className="nav nav-tabs">
									<li className="nav-item" role="presentation">
										<button
											className={`nav-link ${activeTab === 'tab1' ? 'active' : 'text-secondary'}`}
											type="button"
											role="tab"
											onClick={() => setActiveTab('tab1')}
										>
											Associate Alerts to Clients
										</button>
									</li>
									<li className="nav-item" role="presentation">
										<button
											className={`nav-link ${activeTab === 'tab2' ? 'active' : 'text-secondary'}`}
											onClick={() => setActiveTab('tab2')}
											type="button"
											role="tab"
										>
											View Alert Client Associations
										</button>
									</li>
									<li className="nav-item" role="presentation">
										<button
											className={`nav-link ${activeTab === 'tab3' ? 'active' : 'text-secondary'}`}
											onClick={() => setActiveTab('tab3')}
											type="button"
											role="tab"
										>
											Add Client Response Info
										</button>
									</li>
								</ul>
								<br />
								{activeTab === 'tab1' && (
									<div className="card" id="alert_client_div">
										<div className="card-header"><i className="fa fa-file-text"></i>  Associate Alert to Client</div>
										<div className="card-body">
											<form name="alertClientForm" id="alertClientForm" encType="multipart/form-data">
												<div className="row" style={{ position: 'relative' }}>
													<div className="form-group col-md-2" id="mr_number_div">
														<label htmlFor="mr_number" className="text-info fw-bold" id="mrn_label">MR Number</label>
														<input
															type="text"
															className="form-control basicAutoComplete"
															id="mr_number"
															data-noresults-text="No MR Number Found"
															autoComplete="off"
															placeholder="Enter MR Number here"
															value={mrNumber}
															onChange={handleMrNumberChange}
														/>
														{showSuggestions && suggestions.length > 0 && (
															<ul className="list-group position-absolute w-100" style={{ zIndex: 10 }}>
																{suggestions.map((item, idx) => (
																	<li
																		key={idx}
																		className="list-group-item list-group-item-action"
																		style={{ cursor: 'pointer' }}
																		onMouseDown={() => handleSuggestionClick(item)}
																	>
																		{item.mrNumber}
																	</li>
																))}
															</ul>
														)}
													</div>

													<div className="form-group col-md-6" id="mr_number_title_div" style={{ display: showMrNumberTitle ? 'block' : 'none' }} >
														<label className="text-info" id="mrn_label">Alert Title</label>
														&nbsp;&nbsp;
														<span className="badge bg-success pointer-cursor" onClick={() => setShowAlertDetails((prev) => !prev)} disabled={!supportAlert}>
															{showAlertDetails ? (<>
																<i className="fa fa-minus-square"></i> Collapse Alert Details
															</>
															) : (
																<>
																	<i className="fa fa-plus-square"></i> Expand Alert Details
																</>
															)}
														</span>
														<div id="mr_number_title" role="alert">
															{mrNumberTitle}
														</div>
													</div>
													<div className="form-group col-md-4" id="sa_attachments_div">



														<ul className="list-group" id="alert_attachment_list_div">
															<li className="list-group-item active" aria-current="true">{mrNumber}&nbsp;-&nbsp;Existing Alert Attachment(s)</li>
															{allAttachments.length === 0 ? (
																<li className="list-group-item text-danger">No Attachments found</li>
															) : (
																allAttachments.map((file, idx) => (
																	<li className="list-group-item" key={idx}>
																		{file.clientId && <span className='text-primary'>{file.clientId}</span>}
																		{file.clientId && <>&nbsp;-&nbsp;</>}
																		{file.type === 'alert' ? '*' : ''}
																		<a
																			href="#"
																			onClick={e => {
																				e.preventDefault();
																				if (file.type === 'alert') {
																					downloadAttachment(file.id, file.fileName);
																				} else {
																					downloadAttachment(file.id, file.fileName, file.attachmentType);
																				}
																			}}
																		>
																			{file.fileName}
																		</a>
																		&nbsp;
																		<span
																			className="badge bg-danger"
																			style={{ cursor: 'pointer' }}
																			onClick={() => {
																				if (file.type === 'alert') {
																					deleteAlertAttachment(file.id, selectedClientId, 'SA');
																				} else if (file.type === 'client') {
																					// Pass both alertClientId and id for client type
																					deleteClientAttachment(file.id, file.clientId, 'NT');
																				} else {
																					deleteAlertAttachment(file.id, file.attachmentType);
																				}
																			}}
																		>
																			Delete Attachment
																		</span>
																	</li>
																))
															)}
														</ul>

													</div>

												</div>

												<div className="row" id="alert_detail_div">
													<div className="col-12">
														<br />
														{showAlertDetails && supportAlert && (
															<div className="card">
																<div className="card-header">Alert Detail - {supportAlert.mrNumber}</div>
																<div className="card-body text-secondary">
																	<div><strong>Alert Number:</strong> {supportAlert.mrNumber}
																		&nbsp;<strong>Publish Date:</strong>
																		{format(new Date(supportAlert.publishDate), 'M/dd/yyyy')}
																	</div>
																	<div><strong>Title:</strong> {supportAlert.alertTitle}<br /><br /></div>
																	<div>
																		<strong>Description:</strong>{' '}
																		<span
																			dangerouslySetInnerHTML={{
																				__html: unescapeHtml(supportAlert.productDesc || '')
																			}}
																		/>
																		<br /><br />
																	</div>
																	<div><strong>Product Classification:</strong> {supportAlert.productClassification}
																		&nbsp;<strong>Alert Class:</strong> {supportAlert.alertClass}
																		&nbsp;<strong>Category:</strong> {supportAlert.category}
																		&nbsp;<strong>Source:</strong> {supportAlert.alertSource}
																		&nbsp;<strong>Source Number:</strong> {supportAlert.sourceNumber}
																		&nbsp;<strong>Alert Type:</strong> {supportAlert.alertType}
																		&nbsp;<strong>FDA Recall Status:</strong> {supportAlert.fdaAlertStatus}
																		&nbsp;<strong>Vendor Requests Response:</strong> {supportAlert.vendorRequestsResponse}<br /><br />
																	</div>
																	<div><strong>Manufatcurer:</strong> {supportAlert.manufacturer}
																		&nbsp;<strong>Recaller:</strong> {supportAlert.recaller}<br /><br />
																	</div>
																	<div>
																		<strong>Reason:</strong>{' '}
																		<span
																			dangerouslySetInnerHTML={{
																				__html: unescapeHtml(supportAlert.reason || '')
																			}}
																		/>
																		<br /><br />
																	</div>
																	<div>
																		<strong>Recommended Action:</strong>{' '}
																		<span
																			dangerouslySetInnerHTML={{
																				__html: unescapeHtml(supportAlert.recommendedAction || '')
																			}}
																		/>
																		<br /><br />
																	</div>
																	<div><strong>NDC:</strong> {supportAlert.ndc}<br /><br /></div>
																	<div><strong>UPC:</strong> {supportAlert.upc}<br /><br /></div>
																	<div>
																		<strong>Catalog Number:</strong>{' '}
																		<span
																			dangerouslySetInnerHTML={{
																				__html: unescapeHtml(supportAlert.catalogNumber || '')
																			}}
																		/>
																		<br /><br />
																	</div>
																	<div><strong>Distribution:</strong> {supportAlert.distribution}
																		&nbsp;<strong>Quantity:</strong> {supportAlert.quantity}
																		&nbsp;<strong>Source URL:</strong> {supportAlert.sourceUrl}
																		<br /><br />
																	</div>
																	<div>
																		<strong>Contact Info:</strong>{' '}
																		<span
																			dangerouslySetInnerHTML={{
																				__html: unescapeHtml(supportAlert.contactInfo || '')
																			}}
																		/>
																		<br /><br />
																	</div>
																	<div>
																		<strong>Misc Info:</strong>{' '}
																		<span
																			dangerouslySetInnerHTML={{
																				__html: unescapeHtml(supportAlert.miscInfo || '')
																			}}
																		/>
																		<br /><br />
																	</div>
																</div>
															</div>

														)}
													</div>
												</div>
												<div id="client_association_notifier">{clientAssociationNotifier}</div>
												<div className="row">
													<div className="form-group col-md-2">
														<label htmlFor="client_select" className="text-info fw-bold">Select Client</label>

														<select
															id="client_select"
															className="form-select"
															value={selectedClientId}
															onChange={handleClientChange}
														>
															<option value="">Select Client</option>
															{clients.map((client, idx) => (
																<option key={idx} value={client.clientId || client.id}>
																	{client.clientName || client.name}
																</option>
															))}
														</select>

													</div>

													<div className="form-group col-md-6" id="email_notices_div">
														<label className="text-info fw-bold">Received From</label>
														<ul className="list-group">
															{emailNotices.length === 0 ? (
																<li className="list-group-item text-danger">No Email Notices found</li>
															) : (
																emailNotices.map((notice, idx) => (
																	<li className="list-group-item" key={idx}>

																		<input type="checkbox" value={notice.mongoId} name="noticeTaskIds"
																			onChange={handleCBChanged} id={notice.messageId}

																			style={{ marginRight: '8px' }} />
																		<span className="text-primary">{notice.emailFrom || notice.from}</span>&nbsp;-&nbsp;
																		<span>{notice.subject}</span> on <span className="text-success">{format(new Date(notice.emailDate), 'M/dd/yyyy HH:mm')}</span>
																	</li>
																))
															)}
														</ul>
													</div>
													<div className="form-group col-md-4" id="notice_attachment_div">
														<label className="text-info fw-bold">Select Attachments from emails</label>


														<ul className="list-group">
															{noticeAttachments.length === 0 ? (
																<li className="list-group-item text-danger">No Attachments found</li>
															) : (
																noticeAttachments.map((att, idx) => (
																	<li className="list-group-item" key={idx} id={att.messageId}>
																		<input
																			type="checkbox"
																			name="noticeFileIds"
																			value={att.mongoId}
																			style={{ marginRight: '8px' }}
																		/>
																		<a
																			href="#"
																			onClick={e => {
																				e.preventDefault();
																				downloadAttachment(att.mongoId, att.filename, "NT");

																			}}
																		>
																			{att.filename}
																		</a>
																	</li>
																))
															)}
														</ul>


													</div>
												</div>
												<div className="row">
													<div className="form-group col-md-6">
														<br />
														<label htmlFor="alert_file" className="text-info fw-bold">Upload File</label>
														<input
															type="file"
															className="form-control"
															id="alert_file"
															name="alert_file"
															multiple
															onChange={handleFileChange}
														/>
														{selectedFiles.length > 0 && (
															<ul className="mt-2">
																{selectedFiles.map((file, idx) => (
																	<li key={idx}>
																		{file.name}
																		<button
																			type="button"
																			className="btn btn-link btn-sm text-danger ms-2"
																			onClick={() => handleRemoveFile(idx)}
																		>
																			Remove
																		</button>
																	</li>
																))}
															</ul>
														)}
													</div>
													<div className="form-group col-md-6">
														<br />
														<label htmlFor="alert_file" className="text-info fw-bold">Upload Mode:</label>
														<br />
														<input
															type="radio"
															id="upload_selected"
															name="uploadMode"
															value="selected"
															checked={!uploadForAllClients}
															onChange={() => setUploadForAllClients(false)}
														/>
														<label htmlFor="upload_selected" className="ms-1 me-3">
															Upload local file for selected client
														</label>
														<input
															type="radio"
															id="upload_all"
															name="uploadMode"
															value="all"
															checked={uploadForAllClients}
															onChange={() => setUploadForAllClients(true)}
														/>
														<label htmlFor="upload_all" className="ms-1">
															Upload local file for All Clients
														</label>

													</div>

												</div>
												<div className="row">

													<div className="form-group col-md-2">
														<br />
														<label className="text-info fw-bold">Received From(Others)</label>
														<input
															type="text"
															className="form-control"
															id="recvd_from_others"
															name="recvdFromOthers"
															placeholder="Received from (others)"
														/>
													</div>
													<div className="form-group col-md-2">
														<br />
														<label className="text-info fw-bold">Received Date</label>
														<div className="input-group">
															<DatePicker
																selected={receivedDate}
																className="form-control"
																id="received_date"
																placeholderText="Select Received Date"
																dateFormat="MM/dd/yyyy"
																name="receivedDate"
																onChange={(date) => setReceivedDate(date)}
															/>

														</div>
													</div>
													<div className="form-group col-md-2">
														<br />
														<label className="text-info fw-bold">Received Mode</label>
														<select
															id="sel_received_mode"
															name="receivedMode"
															className="form-select"

														>
															<option value="">--Select Received Mode--</option>
															<option value="Email">Email</option>
															<option value="Fax">Fax</option>
															<option value="Online">Online</option>
															<option value="Mail">Mail</option>
															<option value="Oyhers">Others</option>
														</select>
													</div>
													<div className="form-group col-md-6">
														<br />
														<label className="text-info fw-bold">Misc. Info</label>
														<textarea
															className="form-control"
															id="miscInfo"
															name="miscInfo"
															rows="3"
															placeholder="Enter Misc Info Here"

														></textarea>
													</div>
												</div>
												<div className="form-row d-flex justify-content-center mt-3">

													<button
														type="button"
														id="create_alert"
														className="btn btn-danger btn-sm"
														onClick={associateClient}
													>
														Associate Alert to Client
													</button>
												</div>
											</form>
										</div>
									</div>
								)}
								{activeTab === 'tab2' && (
									<div id="view_alert_client_asso_div">
										<div className="card">
											<div className="card-header">View Client Associations</div>
											<div className="card-body">
												<div className="row">

													<div className="form-group col-md-2" id="mr_number_div">
														<label htmlFor="mr_number" className="text-info fw-bold" id="mrn_label2">MR Number</label>
														<input
															type="text"
															className="form-control basicAutoComplete"
															id="mr_number_2"
															data-noresults-text="No MR Number Found"
															autoComplete="off"
															placeholder="Enter MR Number here"
															value={mrNumber}
															onChange={handleMrNumberChange}
														/>
														{showSuggestions && suggestions.length > 0 && (
															<ul className="list-group position-absolute w-100" style={{ zIndex: 10 }}>
																{suggestions.map((item, idx) => (
																	<li
																		key={idx}
																		className="list-group-item list-group-item-action"
																		style={{ cursor: 'pointer' }}
																		onMouseDown={() => handleClickforAlertClient(item)}
																	>
																		{item.mrNumber}
																	</li>
																))}
															</ul>
														)}
													</div>
													<div className="form-group col-md-10">
														<label htmlFor="mr_number" className="text-info fw-bold" id="mrn_label2">Alert Title:</label>
														&nbsp;{mrNumberTitle}
													</div>
												</div>
												<br />
												<div className="row" id="alert_clients_table_div">
													<table className="table table-responsive-sm text-secondary table-bordered  table-sm">
														<thead>
															<tr>
																<th>#</th>
																<th className="text-nowrap">Client Id</th>
																<th>Received from</th>
																<th>Received Date</th>
																<th>MISC Info</th>
																<th>Eneterd By</th>
																<th>EnteredTime</th>
																<th>Attachment List</th>
															</tr>
														</thead>

														<tbody>
															{flatRows.map((row, idx) => {
																if (row.clientId !== lastClientId) {
																	isEvenRow = !isEvenRow;
																	lastClientId = row.clientId;
																}
																return (
																	<tr
																		key={`${row.clientId}-${row.mongoId}-${row.entryIdx}-${idx}`}
																		className={isEvenRow ? 'table-active' : ''}
																	>
																		<td>{row.isFirst ? rowNumber++ : ''}</td>
																		<td>{row.clientId}</td>
																		<td>{row.entry.receivedFrom}</td>
																		<td>{row.entry.receivedDate ? new Date(row.entry.receivedDate).toLocaleString() : ''}</td>
																		<td>{row.entry.miscInfo}</td>
																		<td>{row.entry.enteredBy}</td>
																		<td>{row.entry.enteredTimestamp ? new Date(row.entry.enteredTimestamp).toLocaleString() : ''}</td>
																		<td>
																			{(row.entry.attachments || []).map((att, i) => (
																				<span key={i}>
																					<a
																						href="#"
																						title={`Click to Download Attachment ${att[1]}`}
																						onClick={e => {
																							e.preventDefault();
																							downloadAttachment(att[0], att[1], att[2]);
																						}}
																					>
																						{att[1]}
																					</a>
																					&nbsp;
																					<a
																						href="#"
																						title={`Click to Delete Attachment ${att[1]}`}
																						className="text-danger ms-2"
																						onClick={e => {
																							e.preventDefault();
																							if (att[2] === 'SA') {
																								deleteAlertAttachment(att[0], row.clientId, 'SA');
																							} else if (att[2] === 'NT') {
																								deleteAlertAttachment(att[0], row.clientId, 'NT');
																							}
																						}}
																					>
																						<i className="fa fa-trash"></i>
																					</a>
																					<br />
																				</span>
																			))}
																		</td>
																	</tr>
																);
															})}
														</tbody>
													</table>
												</div>
											</div>
										</div>
									</div>
								)}
								{activeTab === 'tab3' && (
									<div className="card" id="client_resp_info_div">
										<div className="card-header">Add Client Response Info</div>
										<div className="card-body">
											<form onSubmit={handleCrInfoSubmit} autoComplete="off">
												<label className="text-info fw-bold">Client Response Info</label>
												<div className="row">
													<div className="form-group col-md-2" id="mr_number_div">
														<label htmlFor="mr_number" className="text-info fw-bold" id="mrn_label">MR Number</label>
														<input
															type="text"
															className="form-control basicAutoComplete"
															id="mr_number"
															data-noresults-text="No MR Number Found"
															autoComplete="off"
															placeholder="Enter MR Number here"
															value={mrNumber}
															onChange={handleMrNumberChange}
														/>
														{showSuggestions && suggestions.length > 0 && (
															<ul className="list-group position-absolute w-100" style={{ zIndex: 10 }}>
																{suggestions.map((item, idx) => (
																	<li
																		key={idx}
																		className="list-group-item list-group-item-action"
																		style={{ cursor: 'pointer' }}
																		onMouseDown={() => handleSuggestionClick(item)}
																	>
																		{item.mrNumber}
																	</li>
																))}
															</ul>
														)}
													</div>
													<div className="form-group col-md-2">
														<label htmlFor="client_select" className="text-info fw-bold">Select Client</label>
														<select
															id="client_select"
															className="form-select"
															value={selectedClientId}
															onChange={handleClientChange}
														>
															<option value="">Select Client</option>
															{clients.map((client, idx) => (
																<option key={idx} value={client.clientId || client.id}>
																	{client.clientName || client.name}
																</option>
															))}
														</select>

													</div>
													<div className="col-md-8" id="mr_number_title" role="alert">
														<label htmlFor="client_select" className="text-info fw-bold">Alert Title</label><br />
														{mrNumberTitle}
													</div>
												</div>
												<br />
												<div className="row">
													<div className="mb-2 col-md-3">
														<label className="form-label">Contact Info Type</label>
														<select id="sel_info_type" name="contactInfoType" className="form-select" onChange={handleCrInfoChange} value={crInfo.contactInfoType || "not_selected"}>
															<option value="not_selected">--Contact Info Type--</option>
															<option value="contact_info_response_form">Contact info for Returning Response Forms</option>
															<option value="contact_info_customer_support">Contact info for Questions about recall/customer support</option>
															<option value="contact_info_local_rep">Contact Local Representative</option>
															<option value="product_credit_replacement">Product/Component Replacement Or Credit Info</option>
															<option value="no_contact_info">No Contact Info included in recall</option>
															<option value="Other">Other</option>
														</select>
													</div>
													<div className="mb-2 col-md-3">
														<label className="form-label">Company/Department/Group</label>
														<input type="text" className="form-control" id="cdg" name="companyDeptGroup" value={crInfo.companyDeptGroup} onChange={handleCrInfoChange} />
													</div>
													<div className="mb-2 col-md-3">
														<label className="form-label">Contact Person</label>
														<input
															type="text" className="form-control" id="c_p" name="contactPerson" value={crInfo.contactPerson} onChange={handleCrInfoChange} />
													</div>
													<div className="mb-2 col-md-3">
														<label className="form-label">Title Contact Person</label>
														<input type="text" className="form-control" id="title_c_p" name="titleContactPerson" value={crInfo.titleContactPerson} onChange={handleCrInfoChange} />
													</div>
												</div>
												<div className="row">
													<div className="mb-2 col-md-3">
														<label className="form-label">Phone(Multiple Numbers, separate with comma)</label>
														<input type="text" className="form-control" id="phone_contact" name="phoneContact" value={crInfo.phoneContact} onChange={handleCrInfoChange} />
													</div>
													<div className="mb-2 col-md-3">
														<label className="form-label">FAX(Multiple Fax Numbers, separate with comma)</label>
														<input type="text" className="form-control" id="fax_contact" name="faxContact" value={crInfo.faxContact} onChange={handleCrInfoChange} />
													</div>
													<div className="mb-2 col-md-3">
														<label className="form-label">Email</label>
														<input type="text" className="form-control" id="email_contact" name="emailContact" value={crInfo.emailContact} onChange={handleCrInfoChange} />
													</div>
													<div className="mb-2 col-md-3">
														<label className="form-label">Street Address</label>
														<input type="text" className="form-control" id="street_address" name="streetAddress" value={crInfo.streetAddress} onChange={handleCrInfoChange} />
													</div>
												</div>
												<div className="row">
													<div className="mb-2 col-md-3">
														<label className="form-label">City</label>
														<input type="text" autoComplete="off" id="contact_city" className="form-control" name="contactCity" value={crInfo.contactCity} onChange={handleCrInfoChange} />
													</div>
													<div className="mb-2 col-md-3">
														<label className="form-label">State</label>
														<select className="form-select" id="contact_state" name="contactState" onChange={handleCrInfoChange} value={crInfo.contactState || "selst"}>
															<option value="selst">--Select State--</option>
															<option value="AL">Alabama (AL)</option>
															<option value="AK">Alaska (AK)</option>
															<option value="AZ">Arizona (AZ)</option>
															<option value="AR">Arkansas (AR)</option>
															<option value="CA">California (CA)</option>
															<option value="CO">Colorado (CO)</option>
															<option value="CT">Connecticut (CT)</option>
															<option value="DE">Delaware (DE)</option>
															<option value="DC">District Of Columbia (DC)</option>
															<option value="FL">Florida (FL)</option>
															<option value="GA">Georgia (GA)</option>
															<option value="HI">Hawaii (HI)</option>
															<option value="ID">Idaho (ID)</option>
															<option value="IL">Illinois (IL)</option>
															<option value="IN">Indiana (IN)</option>
															<option value="IA">Iowa (IA)</option>
															<option value="KS">Kansas (KS)</option>
															<option value="KY">Kentucky (KY)</option>
															<option value="LA">Louisiana (LA)</option>
															<option value="ME">Maine (ME)</option>
															<option value="MD">Maryland (MD)</option>
															<option value="MA">Massachusetts (MA)</option>
															<option value="MI">Michigan (MI)</option>
															<option value="MN">Minnesota (MN)</option>
															<option value="MS">Mississippi (MS)</option>
															<option value="MO">Missouri (MO)</option>
															<option value="MT">Montana (MT)</option>
															<option value="NE">Nebraska (NE)</option>
															<option value="NV">Nevada (NV)</option>
															<option value="NH">New Hampshire(NH)</option>
															<option value="NJ">New Jersey (NJ)</option>
															<option value="NM">New Mexico (NM)</option>
															<option value="NY">New York (NY)</option>
															<option value="NC">North Carolina (NC)</option>
															<option value="ND">North Dakota (ND)</option>
															<option value="OH">Ohio (OH)</option>
															<option value="OK">Oklahoma (OK)</option>
															<option value="OR">Oregon (OR)</option>
															<option value="PA">Pennsylvania (PA)</option>
															<option value="RI">Rhode Island (RI)</option>
															<option value="SC">South Carolina (SC)</option>
															<option value="SD">South Dakota (SD)</option>
															<option value="TN">Tennessee (TN)</option>
															<option value="TX">Texas (TX)</option>
															<option value="UT">Utah (UT)</option>
															<option value="VT">Vermont (VT)</option>
															<option value="VA">Virginia (VA)</option>
															<option value="WA">Washington (WA)</option>
															<option value="WV">West Virginia (WV)</option>
															<option value="WI">Wisconsin (WI)</option>
															<option value="WY">Wyoming (WY)</option>
														</select>
													</div>
													<div className="mb-2 col-md-3">
														<label className="form-label">Zip</label>
														<input type="text" className="form-control" id="contact_zip" name="contactZip" value={crInfo.contactZip} onChange={handleCrInfoChange} />
													</div>
												</div>


												<div className="mb-2">
													<label className="form-label fw-bold">Save Mode:</label>
													<div>
														<input
															type="radio"
															id="save_selected"
															name="save_mode"
															value="selected"
															checked={!saveForAllClients}
															onChange={() => setSaveForAllClients(false)}
														/>
														<label htmlFor="save_selected" className="ms-1 me-3">
															Save for Selected Client
															{selectedClientId && (
																<span className="ms-2 text-primary">({selectedClientId})</span>
															)}
														</label>
														<input
															type="radio"
															id="save_all"
															name="save_mode"
															value="all"
															checked={saveForAllClients}
															onChange={() => setSaveForAllClients(true)}
														/>
														<label htmlFor="save_all" className="ms-1">Save For All Client</label>
													</div>
												</div>

												<button type="submit" className="btn btn-sm btn-danger">Save Client Response Info</button>
												&nbsp;

												<button type="button" className="btn btn-sm btn-danger" onClick={handleDeleteCrInfo}>
													Delete Client Response Info
												</button>
											</form>
										</div>
									</div>
								)}
							</div>
						</div>
						{showResponseInfoCard && (
							<>
								<br />
								<div className="card" id="response-info-card">
									<div className="card-header">Response Info for Alert - {mrNumber}</div>

									<div className="card-body" id="response-info_loader">
										{/* Top toolbar: page size (left) + search/refresh/cancel (right) */}
										<div className="d-flex justify-content-between align-items-center mb-2">
											<div className="d-flex align-items-center gap-2">
												<label className="mb-0 small text-secondary">Page size</label>
												<select
													className="form-select form-select-sm"
													style={{ width: "110px" }}
													value={responseInfoPageSize}
													onChange={onResponseInfoChangePageSize}
												>
													<option value={10}>10</option>
													<option value={20}>20</option>
													<option value={30}>30</option>
												</select>
											</div>

											<div className="d-flex justify-content-end align-items-center gap-2">
												<div className="input-group input-group-sm" style={{ width: "360px" }}>
													<input
														type="text"
														className="form-control"
														placeholder="Search response info"
														value={responseInfoSearchInput}
														onChange={(e) => setResponseInfoSearchInput(e.target.value)}
														onKeyDown={(e) => {
															// Search should only trigger on icon click; Enter is optional.
															if (e.key === "Enter") onResponseInfoSearchClick();
														}}
													/>
													<button
														type="button"
														className="btn btn-outline-secondary"
														title="Search"
														onClick={onResponseInfoSearchClick}
													>
														<i className="fa fa-search" />
													</button>
													<button
														type="button"
														className="btn btn-outline-secondary"
														title="Refresh"
														onClick={onResponseInfoRefreshClick}
													>
														<i className="fa fa-refresh" />
													</button>
													<button
														type="button"
														className="btn btn-outline-secondary"
														title="Cancel"
														onClick={onResponseInfoCancelClick}
													>
														<i className="fa fa-times" />
													</button>
												</div>
											</div>
										</div>

										{/* Table */}
										<div className="table-responsive">
											<table
												id="response-info-table"
												className="table table-responsive-sm text-secondary table-bordered table-sm table-striped table-hover"
											>
												<thead>
													<tr>
														<th style={{ width: "60px" }}>#</th>
														<th>Client ID</th>
														<th>MR Number</th>
														<th>Contact Info Type</th>
														<th>Company/Dept/Group</th>
														<th>Contact Person</th>
														<th>Title</th>
														<th>Phone</th>
														<th>Fax</th>
														<th>Email</th>
														<th>Address</th>
														<th>City</th>
														<th>State</th>
														<th>Zip</th>
														<th style={{ width: "70px" }}>Delete</th>
													</tr>
												</thead>

												<tbody>
													{responseInfoList.length === 0 ? (
														<tr>
															<td colSpan={14} className="text-danger">
																No Response Info found
															</td>
														</tr>
													) : (
														responseInfoList.map((ri, idx) => (
															<tr key={ri?.mongoId || ri?.id || `${responseInfoPage}-${idx}`}>
																<td className="text-center">
																	{(responseInfoPage - 1) * responseInfoPageSize + idx + 1}
																</td>
																<td>{ri?.clientId}</td>
																<td className="text-nowrap">{ri?.mrNumber}</td>
																<td>{getContactInfoTypeLabel(ri?.contactInfoType)}</td>
																<td>{ri?.companyDeptGroup}</td>
																<td>{ri?.contactPerson}</td>
																<td>{ri?.titleContactPerson}</td>
																<td>{ri?.phoneContact}</td>
																<td>{ri?.faxContact}</td>
																<td>{ri?.emailContact}</td>
																<td>
																	{[ri?.streetAddress, ri?.streetAddress2].filter(Boolean).join(" ")}
																</td>
																<td>{ri?.contactCity}</td>
																<td>{ri?.contactState}</td>
																<td>{ri?.contactZip}</td>
																<td className="text-center">
																	<button
																		type="button"
																		className="btn btn-sm btn-outline-danger"
																		title="Delete"
																		onClick={() => handleDeleteResponseInfoRow(ri)}
																	>
																		<i className="fa fa-trash" />
																	</button>
																</td>
															</tr>
														))
													)}
												</tbody>
											</table>
										</div>

										{/* Pager + totals + jump */}
										<div className="d-flex justify-content-between align-items-center mt-2">
											<div className="small text-secondary">
												Total: {responseInfoTotal} | Page {responseInfoPage} of {responseInfoTotalPages}
											</div>

											<div className="d-flex align-items-center gap-2">
												<button
													type="button"
													className="btn btn-sm btn-outline-secondary"
													disabled={responseInfoPage <= 1}
													onClick={() => goToResponseInfoPage(1)}
												>
													&laquo;
												</button>

												<button
													type="button"
													className="btn btn-sm btn-outline-secondary"
													disabled={responseInfoPage <= 1}
													onClick={() => goToResponseInfoPage(responseInfoPage - 1)}
												>
													Previous
												</button>

												{responseInfoPageWindow.map((p) => (
													<button
														key={p}
														type="button"
														className={`btn btn-sm ${p === responseInfoPage ? "btn-secondary" : "btn-outline-secondary"
															}`}
														onClick={() => goToResponseInfoPage(p)}
													>
														{p}
													</button>
												))}

												<button
													type="button"
													className="btn btn-sm btn-outline-secondary"
													disabled={responseInfoPage >= responseInfoTotalPages}
													onClick={() => goToResponseInfoPage(responseInfoPage + 1)}
												>
													Next
												</button>

												<button
													type="button"
													className="btn btn-sm btn-outline-secondary"
													disabled={responseInfoPage >= responseInfoTotalPages}
													onClick={() => goToResponseInfoPage(responseInfoTotalPages)}
												>
													Last
												</button>

												<div className="d-flex align-items-center gap-1 ms-2">
													<span className="small text-secondary">Jump</span>
													<input
														type="number"
														className="form-control form-control-sm"
														style={{ width: "90px" }}
														min={1}
														max={responseInfoTotalPages}
														value={responseInfoPageJump}
														onChange={(e) => setResponseInfoPageJump(e.target.value)}
														onKeyDown={(e) => {
															if (e.key === "Enter") submitResponseInfoPageJump();
														}}
													/>
													<button
														type="button"
														className="btn btn-sm btn-outline-secondary"
														onClick={submitResponseInfoPageJump}
													>
														Go
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</>
						)}
					</div>
				</div>
			</div>
			<Footer />
		</>
	)
};
export default AlertClient;